import Axios from 'axios'
import Cookies from 'universal-cookie'

const URL = process.env.REACT_APP_BACK_END_URL

const apiInstance = Axios.create({
    baseURL: `${URL}`
})

const cookies = new Cookies();

apiInstance.interceptors.request.use((config) => {
    const jwtCookie = cookies.get('jwt');
    if (jwtCookie) {
        config.headers.Authorization = `Bearer ${jwtCookie}`;
    }
    return config;
});


//League
const GetLeagueByName = async (name) => {
    try {
        const res = await apiInstance.get(`/Rampage/League/Name`, { params: { name: name } })

        if (res) {
            return res
        } else {
            console.log('Could not find league with name: ', name)
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetLeaguesByIds = async (ids) => {
    try {
        const res = await apiInstance.post(`/Rampage/League/Id`, ids)

        if (res) {
            return res
        } else {
            console.log('Could not find any league for the provided Ids:', ids)
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetLeagues = async () => {
    try {
        const res = await apiInstance.get(`/Rampage/League/All`)

        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetLeaderboard = async (leagueId) => {
    try {
        const res = await apiInstance.get(`/Rampage/Leaderboard?leagueId=${leagueId}`)
        if (res) {
            return res
        } else {
            return null
        }

    } catch (error) {
        return null
    }
}

const SyncLeaderboard = async () => {
    try {
        const res = await apiInstance.put(`/Rampage/Leaderboard/sync`)
        if (res){
            return res
        } else {
            return null
        }
    } catch (error) {
        return null
    }
}

const CreateLeague = async (data) => {
    try {
        const res = await apiInstance.post(`/Rampage/League`, data)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const DeleteLeague = async (leagueId) => {
    try {
       console.log("Leaving league")
       
        // const res = await apiInstance.delete(`/League`, { params: { leagueId: leagueId } })
        // if (res) {
        //     return res
        // } else {
        //     return null
        // }
    } catch (err) {
        console.log(err)
        return null
    }
}

const EditLeague = async (data, userId) => {
    try {
        console.log("DATA", data)
        const res = await apiInstance.put(`/Rampage/League?leagueId=${data.leagueId}&userId=${userId}`, data)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const LeaveLeague = async (leagueId, userId, teamId) => {
    try 
    {

        console.log("Leaving league")
        // const res = await apiInstance.delete(`/Team?leagueId=${leagueId}&teamId=${teamId}&userId=${userId}`)
        // if (res) {
        //     return res
        // } else {
        //     console.log('Could not find riders')
        //     return null
        // }
    } catch (error) {
        console.log(error)
        return null
    }
}

//Rider
const GetRiders = async () => {
    try {
        const res = await apiInstance.get(`/Rampage/Riders`)

        if (res) {
            return res
        } else {
            console.log('Could not find riders')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetRidersByEvent = async (eventId) => {
    try{
        const res = await apiInstance.get(`/Rampage/Rider/Event?eventId=${eventId}`)
        if (res) {
            return res
        } else {
            console.log('Could not find riders')
            return null
        }

    } catch(err){
        console.log(err)
        return null
    }
}

const AddRider = async (data) => {
    try {
        const res = await apiInstance.post('/Rampage/Rider', data)

        if (res) {
            return res
        } else {
            console.log("Could not add rider")
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}


//Result
const AddResult = async (data) => {
    try {
        const res = await apiInstance.post(`/Rampage/Result`, data)

        if (res) {
            return res
        } else {
            console.log('Could not add result')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetResults = async () => {
    try {
        const res = await apiInstance.get(`/Rampage/Results`)

        if (res) {
            return res
        } else {
            console.log('Could not get results')
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const GetResultsForTeam = async (teamId) => {
    try {
        const res = await apiInstance.get(`/Rampage/Results/Team?teamId=${teamId}`)
        if (res) {
            return res
        } else {
            console.log('Could not get results')
            return null
        }

    } catch (error) {
        console.log(error)
        return null
    }
}


//Team
const AddTeam = async (data) => {
    try {
        const res = await apiInstance.post(`/Rampage/Team`, data)

        if (res) {
            return res
        } else {
            console.log('Could not create team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const AddUserToLeague = async (userId, leagueId) => {
    try {
        const res = await apiInstance.put(`/Rampage/League/Team?leagueId=${leagueId}&userId=${userId}`)

        if (res) {
            return res
        } else {
            console.log('Could not create team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const GetTeam = async (id) => {
    try {
        const res = await apiInstance.get(`/Rampage/Team`, { params: { id: id } })

        if (res) {
            return res
        } else {
            console.log('Could not get team', id)
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const UpdateTeam = async (data, userId) => {
    try {
        const res = await apiInstance.put(`/Rampage/Team?userId=${userId}`, data)

        if (res) {
            return res
        } else {
            console.log('Could not update team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const GetTeamRiders = async (id) => {
    try {
        const res = await apiInstance.get(`/Rampage/Team/Riders`, { params: { id: id } })
        if (res) {
            return res
        } else {
            console.log('Could no get riders for team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

//Event
const SaveEvent = async (data) => {
    try {
        const res = await apiInstance.post(`/Rampage/Event`, data)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        return null
    }
}

const GetEvents = async () => {
    try {
        const res = await apiInstance.get(`/Rampage/Events`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        return null
    }
}

const GetNextEvent = async () => {
    try {
        const res = await apiInstance.get('/Rampage/Event/Next')
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        return null
    }
}

const DeleteEvent = async (eventId) => {
    try {
        console.log(eventId)
        const res = await apiInstance.delete(`/Rampage/Event?EventId=${eventId}`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

//Admin
const CreateDisabled = async () => {
    try {
        const res = await apiInstance.post('/Admin/Rampage/Disabled')

        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const UpdateDisabled = async (disabled) => {
    try {
        const res = await apiInstance.put('/Admin/Rampage/Disabled', { disabled: disabled })

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const GetDisabled = async () => {
    try {
        const res = await apiInstance.get('/Admin/Rampage/Disabled')

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const DisableEditing = async () => {
    try {
        const res = await apiInstance.put('/Rampage/Admin/Disabled', { disabled: true })

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}


//Snapshots
const GetSnapshots = async () => {
    try {
        const res = await apiInstance.get('/Rampage/Snapshot/All')

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
    }
}

const CreateSnapshot = async (eventId, name) => {
    try {
        const res = await apiInstance.post(`/Rampage/Snapshot/All?eventId=${eventId}&name=${name}`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const DeleteAllSnapshots = async () => {
    try {
        const res = await apiInstance.delete('/Rampage/Snapshot/All')
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
    }
}

const DeleteSnapshotsByName = async (name) => {
    try {
        const res = await apiInstance.delete(`/Rampage/Snapshots/Name?name=${name}`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
    }
}



export {
    //League
    GetLeagueByName,
    GetLeaguesByIds,
    GetLeagues,
    GetLeaderboard,
    SyncLeaderboard,
    CreateLeague,
    EditLeague,
    DeleteLeague,
    LeaveLeague,
    
    //Rider
    GetRiders,
    GetRidersByEvent,
    AddRider,

    //Result
    AddResult,
    GetResults,
    GetResultsForTeam,

    //Team
    AddTeam,
    GetTeam,
    UpdateTeam,
    GetTeamRiders,
    AddUserToLeague,

    //Event
    SaveEvent,
    GetEvents,
    DeleteEvent,
    GetNextEvent,

    //Admin
    UpdateDisabled,
    CreateDisabled,
    GetDisabled,
    DisableEditing,

    //Snapshot
    GetSnapshots,
    CreateSnapshot,
    DeleteAllSnapshots,
    DeleteSnapshotsByName,

}